import uniqWith from 'lodash/uniqWith'
import isEqual from 'lodash/isEqual'
import groupBy from 'lodash/groupBy'

export const getPermissions = (all_permissions_data: any) => {
  const PERMISSION_GROUPS_API = uniqWith(
    all_permissions_data?.permissions?.map((permission) => ({
      [`${permission?.permission_group?.name
        ?.split(' ')
        ?.join('_')
        ?.toUpperCase()}`]: permission?.permission_group?.id,
    })),
    isEqual,
  )

  const PERMISSIONS_API = all_permissions_data?.permissions?.map(
    (permission) => ({
      [`${permission?.name?.split(' ')?.join('_')?.toUpperCase()}`]:
        permission?.id,
    }),
  )

  const PERMISSIONS: any = convert_to_single_object(PERMISSIONS_API)
  const PERMISSION_GROUPS: any = convert_to_single_object(PERMISSION_GROUPS_API)
  return { PERMISSIONS, PERMISSION_GROUPS }
}

const convert_to_single_object = (array) => {
  const obj = {}
  array?.forEach((item) => {
    Object.keys(item)?.forEach((key) => {
      obj[key] = item[key]
    })
  })
  return obj
}
